import { baseUrl, getData, getMainElement } from "./utils";
import { initPoints, render as renderPoints } from "./points";

// demo
let isDemo = false;
let fakePointer = {
  x: 0,
  speed: 1,
};
let fakePointerTimer = 0;

// data
const data = getData();

let initialized = false,
  imgExt = "webp",
  totalFrames = 36,
  activeClass = "active";

// elements
let elDrag = document.getElementById("j360_exterior_drag");
let elContainer = document.getElementById("j360_exterior");
let elLoading = document.getElementById("j360_loading");
let frames = [];

// events
let ready = false;
let currentFrame = 0;
let endFrame = 0;
let dragging = false;
let pointerStartPosX = 0;
let pointerEndPosX = 0;
let pointerDistance = 0;
let monitorStartTime = 0;
let monitorInt = 100;
let speedMultiplier = 2.5;
let ticker = 0;
let navFrame = 5;

function getActiveColor() {
  const elMain = getMainElement();
  const color = elMain.querySelector("input[name=color]:checked");
  if (color) {
    return color.value;
  }
  return "black";
}

// TODO: init data to override variables.
function initData() {}

function initExterior() {
  // only once initialization
  if (initialized) {
    return;
  }

  // data must exist
  if (!data) {
    return;
  }

  // initial frame
  if (data.initialFrame) {
    currentFrame = totalFrames - data.initialFrame;
    endFrame = totalFrames - data.initialFrame;
  }

  if (data.totalFrames) {
    totalFrames = data.totalFrames;
  }
  if (data.navFrame) {
    navFrame = data.navFrame;
  }

  // initialize points.
  initPoints(data.exterior, getNormalizedCurrentFrame());

  elContainer = document.getElementById("j360_exterior");
  elLoading = document.getElementById("j360_loading");

  initialized = true;

  let color = getActiveColor();
  loadImages(color);

  listeners();
}

export function loadImages(color) {
  ready = false;
  let loaded = 0;
  frames = [];

  // empty container
  elContainer.innerHTML = "";

  // repeat frames
  loading(0);
  for (let f = 1; f <= totalFrames; f++) {
    // generate image urls.
    const imgUrl = `${baseUrl}/${data.folder}/exterior/${color}/${f}.${imgExt}`;

    // create img
    const img = new Image();
    img.src = imgUrl;
    img.alt = "";

    const imageDiv = document.createElement("div");
    imageDiv.appendChild(img);
    elContainer.appendChild(imageDiv);
    frames.push(imageDiv);

    img.addEventListener("load", function () {
      loaded++;
      const percent = Math.floor((loaded / totalFrames) * 100);
      loading(percent);

      // all loaded
      if (percent === 100) {
        ready = true;

        // display current frame
        frames[getNormalizedCurrentFrame()].classList.add(activeClass);

        if (isDemo) {
          startDemo();
        }
      }
    });
  }
}

function loading(progress) {
  if (!elLoading) {
    return;
  }

  // display progress
  elLoading.style.display = "flex";
  const span = elLoading.getElementsByTagName("span");
  if (span.length) {
    span.item(0).textContent = progress;
  }

  if (progress >= 100) {
    // TODO: fadein effect.
    elLoading.style.display = "none";
  }
}

function getNormalizedCurrentFrame() {
  var c = -Math.ceil(currentFrame % totalFrames);
  if (c < 0) c += totalFrames;
  return c;
}

function render() {
  if (currentFrame !== endFrame) {
    var frameEasing =
      endFrame < currentFrame
        ? Math.floor((endFrame - currentFrame) * 0.1)
        : Math.ceil((endFrame - currentFrame) * 0.1);
    hidePreviousFrame();
    currentFrame += frameEasing;
    showCurrentFrame();
  } else {
    window.clearInterval(ticker);
    ticker = 0;
  }
}

function refresh() {
  if (ticker === 0) {
    ticker = self.setInterval(render, Math.round(1000 / 100));
  }
}

function hidePreviousFrame() {
  frames[getNormalizedCurrentFrame()].classList.remove(activeClass);
}

function showCurrentFrame() {
  const frame = getNormalizedCurrentFrame();
  frames[frame].classList.add(activeClass);
  renderPoints(frame);

  if (isDemo) {
    console.log(frame + 1);
  }
}

function setDragging(d) {
  dragging = d;
  if (d) {
    elDrag.classList.add("dragging");
  } else {
    elDrag.classList.remove("dragging");
  }
}

function listeners() {
  if (!elDrag) {
    return;
  }

  // dragging events
  elDrag.addEventListener("mousedown", function (event) {
    event.preventDefault();
    pointerStartPosX = getPointerEvent(event).pageX;
    setDragging(true);
  });

  elDrag.addEventListener("mouseup", function (event) {
    event.preventDefault();
    setDragging(false);
  });

  elDrag.addEventListener("mousemove", function (event) {
    event.preventDefault();
    if (!isDemo) {
      trackPointer(event);
    }
  });

  elDrag.addEventListener("touchstart", function (event) {
    event.preventDefault();
    pointerStartPosX = getPointerEvent(event).pageX;
  });
  
  elDrag.addEventListener("touchmove", function (event) {
    event.preventDefault();
    setDragging(true);
    if (!isDemo) {
      trackPointer(event);
    }
  });

  elDrag.addEventListener("touchend", function (event) {
    event.preventDefault();
    setDragging(false);
  });

  // nav events.
  const navLeft = document.getElementById("j360_exterior_left");
  const navRight = document.getElementById("j360_exterior_right");

  navLeft.addEventListener("click", function (ev) {
    ev.preventDefault();
    endFrame -= navFrame;
    refresh();
  });

  navLeft.addEventListener("touchend", function (ev) {
    ev.preventDefault();
    console.log(dragging);
    if (!dragging) {
      endFrame -= navFrame;
      refresh();
    }
  });

  navRight.addEventListener("click", function (ev) {
    ev.preventDefault();
    endFrame += navFrame;
    refresh();
  });

  navRight.addEventListener("touchend", function (ev) {
    ev.preventDefault();
    if (!dragging) {
      endFrame += navFrame;
      refresh();
    }
  });
}

function getPointerEvent(event) {
  return event.changedTouches ? event.changedTouches[0] : event;
}

function getPointerPageX(event) {
  if (isDemo) {
    return fakePointer.x;
  }
  return getPointerEvent(event).pageX;
}

function trackPointer(ev) {
  if (!ready) {
    return;
  }

  if (!dragging && !isDemo) {
    return;
  }

  pointerEndPosX = getPointerPageX(ev);

  if (monitorStartTime < new Date().getTime() - monitorInt) {
    pointerDistance = pointerEndPosX - pointerStartPosX;
    endFrame =
      currentFrame +
      Math.ceil(
        (totalFrames - 1) *
          speedMultiplier *
          (pointerDistance / elContainer.offsetWidth)
      );

    refresh();

    monitorStartTime = new Date().getTime();

    pointerStartPosX = getPointerPageX(ev);
  }
}

function startDemo() {
  fakePointerTimer = window.setInterval(moveFakePointer, 1000);
}

function stopDemo() {
  window.clearInterval(fakePointerTimer);
  fakePointerTimer = 0;
}

function moveFakePointer() {
  fakePointer.x += fakePointer.speed;
  trackPointer();
}

// document.getElementById("demo").addEventListener("click", function (ev) {
//   if (fakePointerTimer) {
//     stopDemo();
//   } else {
//     startDemo();
//   }
// });

// helper to get position
// const clickPositions = [];

// const elPoints = document.getElementById("j360_points");
// elPoints.addEventListener("click", function (event) {
//   event.preventDefault();
//   const containerRect = elPoints.getBoundingClientRect();
//   const xPercent = Math.floor(
//     ((event.clientX - containerRect.left) / containerRect.width) * 100
//   );
//   const yPercent = Math.floor(
//     ((event.clientY - containerRect.top) / containerRect.height) * 100
//   );
//   // const positionText = `[${xPercent}, ${yPercent}] // ${getNormalizedCurrentFrame() + 1}`;
//   const positionText = [xPercent, yPercent];

//   // Add the position to the array
//   clickPositions.push(positionText);
//   console.log(clickPositions);
//   // console.log(positionText);

//   endFrame--;
//   render();
// });

// document.getElementById("copy").addEventListener("click", function (ev) {
//   ev.preventDefault();

//   // Join the array elements with newline characters
//   const positionsText = clickPositions.join("\n");

//   // Create a textarea element to copy the formatted text
//   const textarea = document.createElement("textarea");
//   textarea.value = positionsText;

//   // Append the textarea to the body and select its content
//   document.body.appendChild(textarea);
//   textarea.select();

//   // Copy the selected text to the clipboard
//   document.execCommand("copy");

//   // Remove the textarea from the DOM
//   document.body.removeChild(textarea);
// });

export default initExterior;
